import { render } from "./ModalInfo.vue?vue&type=template&id=731ba127&scoped=true"
import script from "./ModalInfo.vue?vue&type=script&lang=js"
export * from "./ModalInfo.vue?vue&type=script&lang=js"

import "./ModalInfo.vue?vue&type=style&index=0&id=731ba127&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-731ba127"]])

export default __exports__